import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCountries } from '../api/shipmentForms';
import { setCountriesList } from '../redux/app/appActions';
import { RootState } from '../redux/rootReducer';
const useCountriesList = () => {
  const [data, setData]: any[] = useState([]);
  const { countriesList } = useSelector(
    (state: RootState) => state.mainAppData
  );
  const dispatch = useDispatch<any>();
  useEffect(() => {
    getCountriesList();
  }, []);
  const getCountriesList = async () => {
    let localData: any = [];
    if (countriesList && countriesList.length > 0) {
      localData = countriesList;
    } else {
      try {
        const data = await getCountries();
        if (data.data.content && data.data.content.length > 0) {
          localData = data.data.content;
          dispatch(setCountriesList(data.data.content));
        }
      } catch (e) {
        console.log(e);
      }
    }
    setData(localData);
  };
  return data;
};
export default useCountriesList;
